"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const environment_1 = require("src/environments/environment");
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
exports.getAllBatches = (baseURL, access_token) => {
    return axios_1.default
        .get(`${baseURL}/core/deviceTest/batchNumbers`, {
        headers: {
            Authorization: `Bearer ${access_token}`,
        },
        baseURL: '',
        skipInterceptor: true
    })
        .then((res) => {
        return res.data;
    })
        .catch((err) => {
        return err;
    });
};
exports.getDevicesOfBatchNumber = (batchNumber, baseURL, access_token) => {
    return axios_1.default
        .get(`${baseURL}/core/batchNumber/${batchNumber}/device`, {
        headers: {
            Authorization: `Bearer ${access_token}`,
        },
        baseURL: '',
    })
        .then((res) => {
        return res.data;
    })
        .catch((err) => {
        return err;
    });
};
exports.getSensorData = (deviceId, sensorId, from, to, baseURL, access_token) => {
    return axios_1.default
        .get(`${baseURL}/core/device/${deviceId}/sensor/${sensorId}/?from=${from}&to=${to}`, {
        headers: {
            Authorization: `Bearer ${access_token}`,
        },
        baseURL: '',
    })
        .then((res) => {
        return res.data;
    })
        .catch((err) => {
        return err;
    });
};
exports.getSensorData_rca_ms = (deviceId, sensorCode, from, to, baseURL, access_token, userId) => {
    const sensorCodeString = Array.isArray(sensorCode) ? sensorCode.join(",") : sensorCode;
    const formattedFrom = `${from} 00:00:00`;
    const formattedTo = `${to} 23:59:00`;
    return axios_1.default
        .get(`${baseURL}/core/user/${userId}/sensorsAndEventsByDeviceAndCodes`, {
        headers: {
            Authorization: `Bearer ${access_token}`,
        },
        params: {
            deviceId,
            sensorCode: sensorCodeString,
            from: formattedFrom,
            to: formattedTo,
        },
        paramsSerializer: (params) => {
            const query = new URLSearchParams();
            for (const key in params) {
                query.append(key, params[key]);
            }
            return query.toString();
        },
    })
        .then((res) => res.data)
        .catch((err) => err);
};
exports.getAllAvailableModels = (data) => {
    return axios_1.default.get(`${environment_1.environment.MLBE}/model_info_dashboard`, {
        params: data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.deleteModelDB = (model) => {
    const { projectname, problemtype, version_name } = model;
    return axios_1.default.delete(`${environment_1.environment.MLBE}/delete_model_dashboard`, {
        params: {
            projectname,
            problemtype,
            version_name,
        },
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.initiateProject = (projectData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/project_initiation`, projectData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.selectColumnType = (columnSelectionData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/column_selection`, columnSelectionData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.getUniqueLabels = (projectDetails) => {
    return axios_1.default.get(`${environment_1.environment.MLBE}/get_unique_labels`, {
        params: projectDetails,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.handleMissingValues = (nullHandlingData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/null_handling`, nullHandlingData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.outlierRemoval = (outlierRemovalData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/outlier_removal`, outlierRemovalData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.interpolateDataset = (inp) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/interpolate`, inp, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.createLagVariables = (lagVariablesData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/create_lag_variables`, lagVariablesData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.visualizeOutlier = (outlierVisualizationData) => {
    return axios_1.default.get(`${environment_1.environment.MLBE}/visualization_after_outlierremoval`, {
        params: outlierVisualizationData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.visualizeClassification = (outlierVisualizationData) => {
    return axios_1.default.get(`${environment_1.environment.MLBE}/visualization_after_handlingmissingvalues`, {
        params: outlierVisualizationData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.visualizationAfterLagvariables = (outlierVisualizationData) => {
    return axios_1.default.get(`${environment_1.environment.MLBE}/visualization_after_lagvariables`, {
        params: outlierVisualizationData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.featureSelection = (featureSelectionData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/feature_selection`, featureSelectionData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.handleEncoding = (encodingData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/encoding`, encodingData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.handleNormalization = (normalizationData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/normalization`, normalizationData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.handleImbalanceData = (imbalanceMethod) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/handling_imbalanced_data`, imbalanceMethod, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.handleTrainTestSplit = (trainTestRatio) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/train_test_split`, trainTestRatio, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.visualizeAfterSplit = (trainTestVisualizationData) => {
    return axios_1.default.get(`${environment_1.environment.MLBE}/visualization_after_traintestsplit`, {
        params: trainTestVisualizationData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.modelSelection = (modelselectionData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/model_selection`, modelselectionData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.saveModel = (saveModelData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/save_model`, saveModelData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.getSavedModels = (userData) => {
    return axios_1.default.get(`${environment_1.environment.MLBE}/get_saved_models`, {
        params: userData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.selectModel = (finalModelData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/selected_model`, finalModelData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.finalizedModelSaving = (finalizedModelData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/finalizing_model_saving`, finalizedModelData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.binaryThreshold = (binaryThresholding) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/binary_thresholding`, binaryThresholding, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.featureMap = (featureMapping) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/feature_mapping`, featureMapping, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.graphGeneration = (transFormData) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/graph_generation`, transFormData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.graphConfirmation = (data) => {
    return axios_1.default.post(`${environment_1.environment.MLBE}/graph_confirmation`, data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.getFirstCSV = (data) => {
    return axios_1.default.get(`${environment_1.environment.MLBE}/get_first_csv`, {
        params: data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        },
    });
};
exports.getSensorCodes = (baseURL, accesstoken, userId, skipInterceptor) => {
    return axios_1.default.get(`${baseURL}/core/user/${userId}/sensorCodes`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accesstoken}`,
        },
        skipInterceptor: skipInterceptor
    });
};
exports.updateSensorCodes = (sensorData) => {
    return axios_1.default.post(`${environment_1.environment.host}/core/user/${js_cookie_1.default.get("USER_ID")}/sensorCodes`, sensorData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${js_cookie_1.default.get("ACCESS_TOKEN")}`
        }
    });
};
//# sourceMappingURL=api.js.map